module.exports = san.defineComponent({
    template: require('../views/cortCase.html'),
    initData: function () {
        return {
            cortData:{}
        };
    },
    components: {

    },
    created: function() {

    },
    getCort: function(data){
        this.data.set('cortData',data);
    },
    goBack: function(){
        this.dispatch("goBack");
    }
});



//////////////////
// WEBPACK FOOTER
// ./src/components/cortCase.js
// module id = 132
// module chunks = 1